import { render, staticRenderFns } from "./ContactActivities.vue?vue&type=template&id=e2276458&scoped=true&"
import script from "./ContactActivities.vue?vue&type=script&lang=js&"
export * from "./ContactActivities.vue?vue&type=script&lang=js&"
import style0 from "./ContactActivities.vue?vue&type=style&index=0&id=e2276458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2276458",
  null
  
)

export default component.exports